import {useFormikContext} from 'formik'
import {FC} from 'react'

import {FormButton} from '@/components/common/form/FormButton'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {useTranslation} from '@/i18n'
import {verificationMarketsValiditySchema} from '@/utils/validations/common/trademarkVerificationRequest'

import {MarketsInfo} from '../markets/MarketsInfo'
import {TrademarkVerificationFields} from '../types'

type MarketsStepProps = {
  ssrMobileDetected: boolean
}

export const MarketsStep: FC<React.PropsWithChildren<MarketsStepProps>> = ({ssrMobileDetected}) => {
  const {t} = useTranslation()
  const {continueButtonText} = useTrademarkVerificationContent()
  const {values} = useFormikContext<TrademarkVerificationFields>()

  const isButtonDisabled = !verificationMarketsValiditySchema.isValidSync(values)

  return (
    <>
      <MarketsInfo ssrMobileDetected={ssrMobileDetected} />
      {/* <EuipoGrant /> */}
      <FormButton
        dataTest="continueButton"
        text={t(continueButtonText)}
        isInactive={isButtonDisabled}
      />
    </>
  )
}
